import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

import { Snackbar, SnackBarSuccessInterFace } from '../../shared/components/snackbar/snackbar';
import { SnackbarError } from '../../shared/components/snackbar-error/snackbar-error';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackbar = inject(MatSnackBar);

  openSnackbarSuccess(message: string): void {
    const matSnackBarConfig: MatSnackBarConfig<SnackBarSuccessInterFace> = {
      data: {
        message: message,
      },
      duration: 2000,
      verticalPosition: 'top',
    };

    this.snackbar.openFromComponent(Snackbar, matSnackBarConfig);
  }

  openSnackbarError(message: string): void {
    const matSnackBarConfig: MatSnackBarConfig<SnackBarSuccessInterFace> = {
      data: {
        message: message,
      },
      duration: 5000,
      verticalPosition: 'top',
    };

    this.snackbar.openFromComponent(SnackbarError, matSnackBarConfig);
  }
}
